"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDomainEvidence = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const domain_columns_1 = require("./domain-columns");
const domain_fields_1 = require("./domain-fields");
function useDomainEvidence(options) {
    var _a, _b, _c, _d;
    const columns = domain_columns_1.useColumns({
        columns: (_a = options.tableProps) === null || _a === void 0 ? void 0 : _a.columns,
    });
    const defaultSorts = react_1.useMemo(() => { var _a, _b; return (_b = (_a = options.tableProps) === null || _a === void 0 ? void 0 : _a.defaultSorts) !== null && _b !== void 0 ? _b : [
        { field: 'id', datakey: 'id', order: 'DESC', type: 'FIELD' },
    ]; }, [(_b = options.tableProps) === null || _b === void 0 ? void 0 : _b.defaultSorts]);
    const GeneralFieldsComponent = react_1.useMemo(() => function Fields() {
        var _a;
        return (react_1.default.createElement(domain_fields_1.DomainFields, { FieldsComponent: (_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.GeneralFieldsComponent }));
    }, [(_c = options.detailProps) === null || _c === void 0 ? void 0 : _c.GeneralFieldsComponent]);
    const initNewItem = event_callback_hook_1.useEventCallback(() => {
        var _a, _b;
        const obj = {
            id: uuid_1.v4(),
        };
        if (((_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.initNewItem) !== undefined) {
            return {
                ...obj,
                ...(_b = options.detailProps) === null || _b === void 0 ? void 0 : _b.initNewItem(),
            };
        }
        else {
            return obj;
        }
    });
    return {
        ...options,
        tableProps: { ...options.tableProps, columns, defaultSorts },
        detailProps: {
            ...options.detailProps,
            initNewItem,
            GeneralFieldsComponent,
            toolbarProps: (_d = options.detailProps) === null || _d === void 0 ? void 0 : _d.toolbarProps,
        },
    };
}
exports.useDomainEvidence = useDomainEvidence;
//# sourceMappingURL=domain-evidence.js.map